import React from "react";
var __jsx = React.createElement;
import { useEffect } from 'react';
function StylesEffectFade() {
  useEffect(function () {
    import('swiper/css/effect-fade', {
      assert: {
        type: 'css'
      }
    });
  }, []);
  return __jsx(React.Fragment, null);
}
export default StylesEffectFade;